import React from 'react'

import ProjectSession from "../../../../../model2/project/project-session"
import {ProjectSystemType} from "../../../../../model2/project/types"
import FormError from "../../../../../gd-form/common/form-error/form-error"
import FormManager from "../../../../../gd-form/common/form-manager"

// @ts-ignore
import DatePicker from '../../../../../gd-form/form-element/datepicker/datepicker-new'

type Props = {
    form                : FormManager
    project             : ProjectSession

    copyAsTemplate      : boolean
    rescheduleRequired  : boolean
}

export default function ProjectForm_Planning(props: Props) {

    if (props.copyAsTemplate || props.project.isLink) {
        //render nothing
        return null
    } else if ([ProjectSystemType.PROJECT, ProjectSystemType.SPRINT].includes(props.project.systemType)) {
        return (
            <div className="row planning">
                <div className="label">Start/End</div>
                <div className="element">
                    <DatePicker form            = {props.form}
                                name            = "startDate"
                                placeholderText = "Start date"
                                inline          = {true} />
                    <div className="s-e">-</div>
                    <DatePicker form            = {props.form}
                                name            = "endDate"
                                placeholderText = "End date"
                                inline          = {true} />
                    <FormError form={props.form} name="startDate" />
                    <FormError form={props.form} name="endDate" />
                </div>

            </div>
        )
    } else if (props.rescheduleRequired) {
        return (
            <div className="row planning">
                <div className="label">Reschedule</div>
                <div className="element">
                    <DatePicker form            = {props.form}
                                name            = "startDate"
                                placeholderText = "Start date"
                                inline          = {true} />
                    <div className="cf"> </div>
                    <div className="element-hint m-t-5 ui5-txt-no-accent-small lh-13em">
                        Select the start date for the first event/task. Other items will be rescheduled respectively.
                    </div>
                    <FormError form={props.form} name="startDate" />
                    <FormError form={props.form} name="endDate" />
                </div>
            </div>
        )
    }

    return null
}

